import { useTranslation } from "react-i18next";
import { ScrollArea, ScrollBar } from "@/components/atomic/ScrollArea";
import { useConversation } from "@/hooks/useConversation";
import { useChatStore } from "@/stores/ui/useChatStore";
import { useDeepAnalysisStore } from "@/stores/ui/useDeepAnalysisStore";

export const ChatHistory = () => {
  const { t } = useTranslation("voiceek_ui");

  const {
    conversations,
    loadMoreConversations,
    hasMoreConversations,
    isLoadingConversations,
  } = useConversation();
  const setCurrentConversationId = useChatStore((state) => state.setCurrentConversationId);
  const openChatModal = useDeepAnalysisStore((s) => s.openChatModal);

  const handleConversationSelect = (conversationId: string) => {
    setCurrentConversationId(conversationId);
    openChatModal();
  };
  return (
    <div className="pl-10 w-full flex-1 min-h-0 flex flex-col">
      <div className="h-px w-full bg-[#7085BE] mb-4 mt-2" />
      <span className="font-bold text-[#A9B5D6] text-[12px] transition-all text-nowrap">{t("chat.history")}</span>
      <div className="mt-2 flex h-full min-h-0">
        <ScrollArea>
          {conversations?.map((conversation) => (
            <button
              key={conversation.id}
              className="py-2 pl-2.5 pr-1 w-50 text-start text-white rounded-[10px] font-semibold hover:bg-[#5D77BE] hover:cursor-pointer "
              onClick={() => handleConversationSelect(conversation.id)}
            >
              <span className="block truncate">{conversation.name}</span>
            </button>
          ))}
          {hasMoreConversations && (
            <div className="w-full flex justify-center">
              <button
                disabled={isLoadingConversations}
                onClick={loadMoreConversations}
                className="mt-2 text-white mb-2 text-[10px] bg-[#8293C4] px-4 py-1 rounded-full hover:cursor-pointer hover:bg-[#9BA4CC]"
              >
                {t("chat.loadMore")}
              </button>
            </div>
          )}
          <ScrollBar />
        </ScrollArea>
      </div>
    </div>
  );
};
